import { api as gridApi} from './lotsGridActions';
import { api as editStatusDialogApi } from '../Dialogs/EditStatusDialog/editStatusDialogActions';
import {api as exportApi} from '../Export/exportActions';

/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {};

/////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {};

jsxActions.reload = function() {
  return function(dispatch, getState) {
    gridApi.reload(dispatch, getState)();
  }
};

jsxActions.clearFilters = function () {
  return function (dispatch, getState) {
    gridApi.clearFilters(dispatch, getState)();
  }
};

jsxActions.onEditStatus = function (data) {
  return function (dispatch, getState) {
    editStatusDialogApi.show(dispatch, getState)(data);
  }
};

jsxActions.exportCoCAutomationTemplate = function (cocAutomationTemplateId) {
  return function (dispatch, getState) {
    exportApi.exportCoCAutomationTemplate(dispatch, getState)(cocAutomationTemplateId);
  }
};

/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
export let api = {};
